import Axios from '../utils/Axios';
export type PartnerListType = {
  sales_id: number;
  sales_name: string;
  sales_type: number;
  users: UserListType[];
};
export type PartnerReportListType = {
  sales_relation_id: number;
  admin_user_id: number;
  user_name: string;
  sales_id: number;
  sales_name: string;
  report_month_id: number;
  year: number;
  month: number;
  store_id: number;
  store_name: string;
  store_open_date: string;
  real_open_hour: number;
  regist_open_hour: number;
  open_rate: number;
  order_count: number;
  complete_order_count: number;
  complete_order_rate: number;
  late_order_count: number;
  cancel_count: number;
  confirmed_avg_sec: number;
  cook_complete_rate: number;
  on_time_delivery_count: number;
  created_at: string;
  updated_at: string;
  entry_fee: number;
  entry_fee_created_at: string;
  entry_fee_verified_at: string;
  entry_fee_paid_at: string;
  entry_fee_paid_by: string;
  first_maint: number;
  first_maint_created_at: string;
  first_maint_verified_at: string;
  first_maint_paid_at: string;
  first_maint_paid_by: string;
  second_maint: number;
  second_maint_created_at: string;
  second_maint_verified_at: string;
  second_maint_paid_at: string;
  second_maint_paid_by: string;
  third_maint: number;
  third_maint_created_at: string;
  third_maint_verified_at: string;
  third_maint_paid_at: string;
  third_maint_paid_by: string;
  is_all_paid: number;
  all_paid_at: string;
  paid_amount: string;
  month_paid_amount: string;
  prepaid_amount: string;
  is_pay_fulfilled: number;
  reason: string;
  payment_amount: string;
  settlement_amount: string;
  store_created_at: string;
};
export type UserListType = {
  user_id: number;
  user_name: string;
};
export type SalesListType = {
  store_id: number;
  store_name: string;
  sales_relation: SalesRelationType;
};
export type SalesRelationType = {
  sales_id: number;
  sales_name: string;
  user_id: number;
  user_name: string;
};
export type StoreStatusData = {
  bcode: string;
  bcode_name: string;
  store_meta: StoreMetaData[];
};
export type StoreMetaData = {
  log: StoreLogData[];
  parent_store_sector_id: number;
  parent_store_sector_name: string;
  store_id: number;
  store_name: string;
};
export type StoreLogData = {
  created_at: string;
  date: string;
  hour: number;
  pause: number;
  store_availability_yn: number;
  store_login_yn: number;
  store_open_yn: number;
};
export type HotelSettleType = {
  account_holder: string;
  account_nm: string;
  ad_amount: number;
  ad_fee: number;
  ad_fee_rate: string;
  ad_fee_supply: number;
  ad_fee_vat: number;
  bank_name: string;
  created_at: string;
  device_support_fee: number;
  device_support_round: number;
  device_support_status: number;
  device_support_supply: number;
  device_support_vat: number;
  direct_fee: number;
  direct_fee_supply: number;
  direct_fee_vat: number;
  email: string;
  final_fee: number;
  final_supply: number;
  final_vat: number;
  full_name: string;
  month: number;
  phone_number: string;
  rental_fee: number;
  rental_supply: number;
  rental_vat: number;
  room_tip_amount: number;
  room_tip_pay_fee: number;
  room_tip_pay_rate: string;
  status: number;
  store_id: number;
  store_name: string;
  tax_bill: number;
  year: number;
};

const PartnerController = {
  getUsersBySales: async () => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/sales/getUsersBySales';
      const response = await Axios.post(sUrl, {});
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 파트너스사 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getHotelAndStoreSalesRelation: async () => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getHotelAndStoreSalesRelation';
      const response = await Axios.post(sUrl, {});
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 전체 호텔 매장 리스트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getUserXStoreIdsBySales: async (salesId: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/sales/getUserXStoreIdsBySales';
      const response = await Axios.post(sUrl, salesId);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 영업사 맵핑 정보 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setSalesRelation: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/sales/setSalesRelation';
      const response = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 영업사 맵핑 정보 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  storeStatusLogs: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/storeStatusLogs';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[storeStatusLogs 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default PartnerController;
